import { useConnectionState, type ConnectionState } from '../api/connection';
import { StatusBarWindows } from '../dock/StatusBarWindows';
import { strings } from '../strings';
import { useRouteEntities, type RouteEntities } from './routeContext';

const s = strings.shell.status;

const STATE: Record<ConnectionState, { text: string; color: string }> = {
  online: { text: s.online, color: 'var(--success)' },
  reconnecting: { text: s.reconnecting, color: 'var(--warning)' },
  offline: { text: s.offline, color: 'var(--warning)' },
};

/** The page context for pages that don't set their own: deployment and run pages. */
function routeStatus({ context, blueprint, deployment, run }: RouteEntities): string | null {
  if (context.page === 'deployment' && deployment && blueprint) {
    return s.deployment(blueprint.name, deployment.name);
  }
  if (context.page === 'run' && run && deployment) {
    return s.run(deployment.name, strings.status.runKind[run.kind].toLowerCase());
  }
  return null;
}

/** The status bar (spec 6.1.8): connection state, the page's context, the tool-window buttons and Layout menu. */
export function StatusBar({ pageStatus }: { pageStatus: string | null }) {
  const state = STATE[useConnectionState()];
  const entities = useRouteEntities();
  const context = pageStatus ?? routeStatus(entities);
  return (
    <footer data-region="status" tabIndex={-1} aria-label={s.label} className="statusbar">
      <span role="status" className="inline-flex shrink-0 items-center gap-1.5">
        <span aria-hidden className="status-dot" style={{ background: state.color }} />
        {state.text}
      </span>
      {context && <span className="min-w-0 truncate">{context}</span>}
      <StatusBarWindows />
    </footer>
  );
}
